import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { loadPdfLogoDataUrl } from "./pdfLogo";

import { formatJalaliDate, formatJalaliDateTime } from "../shop/utils/dateFormat";
export async function exportBalancePaymentsToPDF(payments, filename = "collected_payments.pdf") {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let currentY = 10;
  const logoDataUrl = await loadPdfLogoDataUrl();

  doc.setProperties({
    title: "Collected Payments Report",
    subject: "Collected Payments Data Export",
    creator: "Tawakal Noorzai Trading Company",
  });

  // --- HEADER ---
  const addHeader = () => {
    const shopName = "شرکت تجارتی توکل نورزی";

    try {
      if (logoDataUrl) {
        doc.addImage(logoDataUrl, "JPEG", pageWidth - 25, 2, 10, 10);
      }
    } catch (error) {
      console.error("Failed to load logo:", error);
    }

    doc.setFontSize(15);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(51, 102, 204);
    doc.text("Collected Payments Report", pageWidth / 2, 9, { align: "center" });

    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(80, 80, 80);
    doc.text(shopName, 10, 7);

    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Generated: ${formatJalaliDate()}`, 10, 11);

    return 18;
  };

  currentY = addHeader();

  // Calculate summary totals
  const totalAmount = payments.reduce((acc, payment) => acc + (parseFloat(payment.amount) || 0), 0);

  // --- BALANCE PAYMENTS TABLE ---
  autoTable(doc, {
    head: [["ID", "Customer", "Amount", "Currency", "Payment Date", "Notes"]],
    body: payments.map((payment) => {
      const paymentDate = payment.payment_date 
        ? formatJalaliDateTime(payment.payment_date)
        : "-";
      
      return [
        payment.id,
        payment.customer_details?.name || "-",
        payment.amount ?? "0.00",
        payment.currency_details?.title || "-",
        paymentDate,
        payment.notes || "-",
      ];
    }),
    startY: currentY,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      halign: "center",
      valign: "middle",
      lineColor: [220, 220, 220],
      lineWidth: 0.1,
    },
    headStyles: {
      fontSize: 8,
      fontStyle: "bold",
      fillColor: [51, 102, 204],
      textColor: [255, 255, 255],
    },
    alternateRowStyles: {
      fillColor: [245, 245, 250],
    },
    margin: { top: 2, bottom: 2, left: 3, right: 3 },
    didDrawPage: function (data) {
      if (data.pageNumber > 1) currentY = addHeader();
    },
  });

  currentY = doc.lastAutoTable.finalY + 5;

  // Add summary table
  if (currentY > pageHeight - 40) {
    doc.addPage();
    currentY = addHeader();
  }

  autoTable(doc, {
    head: [["Summary", "Total Amount"]],
    body: [["TOTAL", `${totalAmount.toFixed(2)}`]],
    startY: currentY,
    styles: {
      fontSize: 9,
      cellPadding: 3,
      halign: "center",
      fontStyle: "bold",
    },
    headStyles: {
      fontSize: 10,
      fontStyle: "bold",
      fillColor: [51, 102, 204],
      textColor: [255, 255, 255],
    },
    bodyStyles: {
      fillColor: [245, 245, 245],
      fontStyle: "bold",
    },
    margin: { left: 3, right: 3 },
  });

  // --- FOOTER ---
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);

    doc.setDrawColor(200, 200, 200);
    doc.setLineWidth(0.5);
    doc.line(0, pageHeight - 11, pageWidth, pageHeight - 11);

    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("تجزوی هول سیل", pageWidth / 2, pageHeight - 5, {
      align: "center",
    });

    doc.setFontSize(7);
    doc.setTextColor(150, 150, 150);
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - 15, pageHeight - 5, {
      align: "right",
    });
  }

  doc.save(filename);
}

